import { ActionsUnion, createAction } from '../helpers';
import { IFastForwardPayload, ILoginPayload, IToken } from './types';

export enum EAuthActionType {
  AUTH_DATA_CLEANUP = 'AUTH/DATA_CLEANUP',
  FAST_FORWARD_NAVIGATE = 'AUTH/FAST_FORWARD_NAVIGATE',
  LOGIN = 'AUTH/LOGIN',
  LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS',
  LOGOUT = 'AUTH/LOGOUT',
  RESET_STORE = 'STORE/RESET',
}

export const authActions = {
  login: (payload: ILoginPayload) =>
    createAction(EAuthActionType.LOGIN, payload),
  authDataCleanup: () => createAction(EAuthActionType.AUTH_DATA_CLEANUP),
  loginSuccess: (token: IToken) =>
    createAction(EAuthActionType.LOGIN_SUCCESS, { token }),
  logout: () => createAction(EAuthActionType.LOGOUT),
  resetStore: () => createAction(EAuthActionType.RESET_STORE),
  fastForwardNavigate: (payload: IFastForwardPayload) =>
    createAction(EAuthActionType.FAST_FORWARD_NAVIGATE, payload),
};

export type TAuthAction = ActionsUnion<typeof authActions>;
